import React from "react";

 function Title() {
    return (
      <header>
        <div className="title">
          <h1>Maiores Campeões Mundiais</h1>
        </div>
      </header>
    );
  }
  
  export default Title;